export default ({ clockSkewAdjustment }) => clockSkewAdjustment;
